// Mega menu toggle (mobile/tablet — the panel is always visible at the `lg` breakpoint).
// Two buttons can open the same panel: the labeled dropdown in the header
// (desktop) and the icon-only one in the floating quick-contact bar
// (mobile) — only one is visible at a time (CSS), but both are kept in
// sync so either reflects the panel's open/closed state.
const megaMenuToggles  = document.querySelectorAll('.js-mega-menu-toggle');
const megaMenu         = document.querySelector('.js-mega-menu');
const megaMenuList     = document.getElementById('site-menu__mega-menu-list');
const megaMenuBackdrop = document.querySelector('.js-mega-menu-backdrop');
const heroLayout = document.querySelector('.js-hero-layout');
// Below `lg` the panel is a fixed, 100dvh off-canvas drawer (CSS-driven
// height); matching the hero's height by JS only makes sense for the
// desktop dropdown. Pages without a hero fall back to the panel's own
// max-height (see _header.scss) instead of an explicit height.
const isDesktopMegaMenu = () => window.matchMedia('(min-width: 1024px)').matches;

if (megaMenuToggles.length && megaMenu && megaMenuList) {
	const setOpen = (isOpen) => {
		megaMenuToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(isOpen)));
		megaMenu.style.height = isDesktopMegaMenu() && heroLayout ? heroLayout.offsetHeight + 'px' : '';
		megaMenu.setAttribute('aria-hidden', String(!isOpen));
		megaMenuList.classList.toggle('is-open', isOpen);
		if (megaMenuBackdrop) {
			megaMenuBackdrop.classList.toggle('is-open', isOpen);
		}
	};

	megaMenuToggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			setOpen(toggle.getAttribute('aria-expanded') !== 'true');
		});
	});

	// Close when clicking outside every toggle and the menu itself.
	document.addEventListener('click', (e) => {
		const clickedToggle = Array.prototype.some.call(megaMenuToggles, (toggle) => toggle.contains(e.target));
		if (!clickedToggle && !megaMenu.contains(e.target)) {
			setOpen(false);
		}
	});
}

// Level-2 flyouts (.site-menu__mega-menu__children) — on desktop the panel
// scrolls vertically (overflow-y: auto, capped at the hero's height above),
// which forces overflow-x to clip too. A flyout positioned with `fixed`
// escapes that clipping (no ancestor here creates a containing block for
// it), but then needs its top/left computed manually since it's no longer
// placed relative to its parent item.
const megaMenuFlyoutItems = megaMenu ? megaMenu.querySelectorAll('.site-menu__mega-menu__item.has-children') : [];

if (megaMenuFlyoutItems.length) {
	let openFlyout = null;

	const positionFlyout = ({ item, flyout }) => {
		const rect = item.getBoundingClientRect();
		flyout.style.top = rect.top + 'px';
		flyout.style.left = rect.right + 'px';
	};

	const openFlyoutFor = (item) => {
		if (!isDesktopMegaMenu()) return;
		const flyout = item.querySelector(':scope > .site-menu__mega-menu__children');
		if (!flyout) return;
		openFlyout = { item, flyout };
		positionFlyout(openFlyout);
	};

	const closeFlyout = () => {
		openFlyout = null;
	};

	megaMenuFlyoutItems.forEach((item) => {
		item.addEventListener('mouseenter', () => openFlyoutFor(item));
		item.addEventListener('focusin', () => openFlyoutFor(item));
		item.addEventListener('mouseleave', closeFlyout);
		item.addEventListener('focusout', (e) => {
			if (!item.contains(e.relatedTarget)) closeFlyout();
		});
	});

	// Reposition on scroll of the panel itself (its content can be taller
	// than the panel) and on resize (item position/box size can change).
	megaMenu.addEventListener('scroll', () => openFlyout && positionFlyout(openFlyout));
	window.addEventListener('resize', () => openFlyout && positionFlyout(openFlyout));
}